export const formatCurrency = (
  amount: number,
  isDiscount?: boolean,
  currency?: string,
): string => {
  const formatted = `$${Math.abs(amount).toFixed(0)} ${currency || 'USD'}`;
  return isDiscount ? `-${formatted}` : formatted;
};
